import { render, staticRenderFns } from "./StocklistTransitTable.vue?vue&type=template&id=6affc353&scoped=true&"
import script from "./StocklistTransitTable.vue?vue&type=script&lang=js&"
export * from "./StocklistTransitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6affc353",
  null
  
)

export default component.exports